import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UnitBankAccountFee } from 'src/app/shared/models/unit-bank-account/UnitBankAccountFee.model';

@Component({
  selector: 'terra-unit-bank-account-fees-table',
  templateUrl: './unit-bank-account-fees-table.component.html',
  styleUrls: ['./unit-bank-account-fees-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitBankAccountFeesTableComponent implements OnInit {

  @Input() fees: UnitBankAccountFee[] = [];

  // consts
  readonly feesColumns = ['type', 'description', 'fees'];

  constructor() { }

  ngOnInit(): void {
  }

}
